import { Box, Link } from '@mui/material';
import { useMemo } from 'react';
import { Cell } from 'react-table';
import { IMassMailingLog } from 'wisestep-api';
import { WsDataTable, WsTypoColors, WsTypography, timeSince, WsTypoVariants } from 'wisestep-base';

interface BroadCastListTableProps {
  data: IMassMailingLog[];
}

const BroadCastListTable = ({ data }: BroadCastListTableProps) => {
  const columns = [
    {
      Header: 'To',
      accessor: 'to',
    },
    {
      Header: 'Subject',
      accessor: 'subject',
      Cell: (cell: Cell) => <Link>{cell.value}</Link>,
    },
    {
      Header: 'Jobs',
      accessor: 'jobs',
      Cell: (cell: Cell) => <WsTypography color={WsTypoColors.BLACK}>{cell.value}</WsTypography>,
    },
    {
      Header: 'Sent On',
      accessor: 'sentOn',
      Cell: (cell: Cell) => (
        <Box display={'flex'} justifyContent={'space-between'}>
          <WsTypography variant={WsTypoVariants.BODY2}>{cell.value}</WsTypography>
        </Box>
      ),
    },
    {
      Header: 'Sent By',
      accessor: 'sentBy',
      Cell: (cell: Cell) => (
        <Box display={'flex'} justifyContent={'space-between'}>
          <WsTypography variant={WsTypoVariants.BODY2}>{cell.value}</WsTypography>
        </Box>
      ),
    },
  ];

  const DATA = useMemo(
    () =>
      data?.map((vendor) => ({
        vendorList: 'jobs',
        to: vendor?.toEmail?.[0] ?? '',
        subject: vendor.subject ?? '',
        jobs: vendor.jobs?.[0]['title'] ?? '',
        contentType: vendor.MassMailType,
        sentBy: vendor.createdBy,
        sentOn: timeSince(String(vendor.createdOn)),
        details: vendor.massMailingGroupId,
      })),
    [data]
  );

  return (
    <Box>
      {data?.length > 0 && (
        <WsDataTable
          columns={columns}
          data={DATA || []}
          totalDataItems={DATA && DATA.length}
          boldItems={['vendorList', 'subject']}
          pageable={false}
        />
      )}
    </Box>
  );
};

export default BroadCastListTable;
